/**
 * The CTA bar under the composer (v11.html markup 294, CSS `.ctabar` 141–143).
 *
 * Two doors, and they must produce distinguishable signals — a first version
 * that merged them lost the agent signal entirely. Both doors capture the
 * email only (2026-09-11); the differentiator is **which door was chosen**,
 * carried by `intent`, not the button weight.
 *
 * **Both buttons are CtaButtons, identically weighted.** That is a recorded
 * override of the one-orange-per-screen rule, and it is deliberate: the doors
 * exist to be compared, so unequal weight would bias the very ratio the bar is
 * here to measure. An earlier revision paired one CtaButton with a
 * SecondaryButton and, in doing so, decided the outcome in CSS.
 */

import { CtaButton } from '@workspace/ui/components/dsm/cta-button'
import { useAskProfile } from '../context/ask-profile-context'

export function AskProfileDoors() {
  const ask = useAskProfile()

  return (
    <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-border pt-3.5">
      <span className="min-w-[200px] flex-1 text-[12.5px] text-muted-foreground">
        <b className="font-semibold text-foreground">Track this startup as it progresses.</b> See if
        it fits your thesis.
      </span>
      <CtaButton size="sm" onClick={() => ask.openDoor('agent_follow', 'cta_bar')}>
        Follow this startup
      </CtaButton>
      <CtaButton size="sm" onClick={() => ask.openDoor('thesis_fit', 'cta_bar')}>
        Evaluate against your thesis
      </CtaButton>
    </div>
  )
}
